import {ApprovalMemberFilters, conditions} from "@repo/services";

/**
 * Filter expression list used to restrict the approval-member picker to production/operations-eligible employees. Currently empty (all clauses commented out), so it imposes no filtering until re-enabled.
 */
export const productionQuery = [
    // {
    //     condition: conditions.and,
    //     expressions: [
    //         {
    //             key: 'aimAssignable',
    //             value: true
    //         }
    //     ]
    // },
    // {
    //     condition: conditions.or,
    //     expressions: [
    //         {
    //             key: 'isProduction',
    //             value: true
    //         },
    //         {
    //             key: 'workEmail',
    //             value: 'drose@agreserves.com'
    //         },
    //         {
    //             key: 'workEmail',
    //             value: 'sbaird@agreserves.com'
    //         }
    //     ]
    // }
];

/**
 * Filter expression list used to restrict the approval-member picker to finance-eligible employees. Currently empty (all clauses commented out), so it imposes no filtering until re-enabled.
 */
export const financeQuery: ApprovalMemberFilters[] = [
    // {
    //     condition: conditions.and,
    //     expressions: [
    //         {
    //             key: 'isFinance',
    //             value: true
    //         },
    //         {
    //             key: 'aimAssignable',
    //             value: true
    //         }
    //     ]
    // }
];

/**
 * Filter expression list used to restrict the approval-member picker to land-eligible employees. Currently empty (all clauses commented out), so it imposes no filtering until re-enabled.
 */
export const landQuery = [
    // {
    //     condition: conditions.and,
    //     expressions: [
    //         {
    //             key: 'isLand',
    //             value: true
    //         },
    //         {
    //             key: 'aimAssignable',
    //             value: true
    //         }
    //     ]
    // }
];

/**
 * Filter expression list used to restrict the approval-member picker to legal-eligible employees. Currently empty (all clauses commented out), so it imposes no filtering until re-enabled.
 */
export const legalQuery = [
    // {
    //     condition: conditions.and,
    //     expressions: [
    //         {
    //             key: 'aimAssignable',
    //             value: true
    //         }
    //     ]
    // },
    // {
    //     condition: conditions.or,
    //     expressions: [
    //         {
    //             key: 'isLegal',
    //             value: true
    //         },
    //         {
    //             key: 'workEmail',
    //             value: 'drose@agreserves.com'
    //         },
    //         {
    //             key: 'workEmail',
    //             value: 'sbaird@agreserves.com'
    //         }
    //     ]
    // }
];
